// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BYDsDkUk6LQZSUWXj6Ch{margin-top:9px;overflow:auto}.SMc76czmVocbjqv8f7r6{border-top:1px solid var(--border-neutral-default)}.yKibs5UnjFAyx4exCXoj,.xl_eHImznUow_8_jsp4_{margin-top:40px;margin-bottom:10px;display:inline-flex}.hqKqei7LyQsMUL6lPFdr{background:var(--border-neutral-default);height:1px;margin:15.5px 0}.yUTNuCN1rqsAvsAzLLLY{flex-wrap:wrap;gap:4px;display:flex}.w6KqR7206n0kB1Rkqe4A{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);color:var(--content-primary-primary);border-radius:6px;padding:4px 8px;display:flex}.E6o4PdHMcJXe6YlD3LT4{flex-direction:column;display:flex}.fI9nc8ySmNAyJ0thUPVF{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BYDsDkUk6LQZSUWXj6Ch`,
	"topBorder": `SMc76czmVocbjqv8f7r6`,
	"link": `yKibs5UnjFAyx4exCXoj`,
	"title": `xl_eHImznUow_8_jsp4_`,
	"divider": `hqKqei7LyQsMUL6lPFdr`,
	"regionsWrap": `yUTNuCN1rqsAvsAzLLLY`,
	"region": `w6KqR7206n0kB1Rkqe4A`,
	"address": `E6o4PdHMcJXe6YlD3LT4`,
	"field": `fI9nc8ySmNAyJ0thUPVF`
};
export default ___CSS_LOADER_EXPORT___;
